import { PermissionsBanTypes, UserRoles } from "../types";
import { PersonaErrorType } from "./types";
const PERSONA_ERRORS = {
    [PersonaErrorType.CREATE_PERSONA]: "Unable to create persona.",
    [PersonaErrorType.UPDATE_PERSONA]: "Unable to update persona.",
    [PersonaErrorType.DELETE_PERSONA]: "Unable to delete persona.",
    [PersonaErrorType.GET_PERSONA]: "Unable to get persona.",
    [PersonaErrorType.SET_DEFAULT_PERSONA]: "Unable to set default persona.",
    [PersonaErrorType.DELETE_DEFAULT_PERSONA]: "Unable to delete default persona.",
    [PersonaErrorType.GET_DEFAULT_PERSONA]: "Unable to get default persona.",
    [PersonaErrorType.CHANGE_PERSONA]: "Unable to change persona.",
    [PersonaErrorType.NO_PERSONA_FOUND]: "No persona found.",
    [PersonaErrorType.NO_DEFAULT_PERSONA_FOUND]: "No default persona found.",
    [PersonaErrorType.NO_PERSONA_SELECTED]: "No persona selected.",
};
const BANNED_USER_TEXT = {
    [PermissionsBanTypes.RESTRICTION_COMPLETE]: {
        title: "Terminated!",
        content: "Your account has been permanently banned due to a voilation of our community guidelines. If you believe this is a mistake or wish to discuss this further, please, get in touch. We're here to help.",
        primaryActionText: "CONTACT US",
        secondaryActionText: "",
    },
    [PermissionsBanTypes.RESTRICTION_TEMPORARY]: {
        title: "Temporary Hold!",
        content: "Your account has been temporarily banned for {{}} hours. We encourage you to review our community guidelines during this time. If you need assistance, contact us.",
        primaryActionText: "VISIT GUIDELINES",
        secondaryActionText: "CONTACT US",
    },
    [PermissionsBanTypes.LIMITED_ACCESS]: {
        title: "Restricted!",
        content: "Your account currently has restricted access. You can continue to chat, but uploading and editing bots is temporarily disabled.",
        primaryActionText: "CONTINUE TO SITE",
        secondaryActionText: "CONTACT US",
    },
};
export var PersonaLimit;
(function (PersonaLimit) {
    PersonaLimit[PersonaLimit["FREE"] = 3] = "FREE";
    PersonaLimit[PersonaLimit["PAID_MINIMAL"] = 10] = "PAID_MINIMAL";
    PersonaLimit[PersonaLimit["PAID_BASIC"] = 50] = "PAID_BASIC";
    PersonaLimit[PersonaLimit["PAID_PREMIUM"] = 100] = "PAID_PREMIUM";
})(PersonaLimit || (PersonaLimit = {}));
const PERSONAS_PER_SUBSCRIPTION = {
    [UserRoles.MINIMAL]: {
        personaLimit: PersonaLimit.PAID_MINIMAL,
        title: "Get A Taste",
    },
    [UserRoles.BASIC]: {
        personaLimit: PersonaLimit.PAID_BASIC,
        title: "True Supporter",
    },
    [UserRoles.PREMIUM]: {
        personaLimit: PersonaLimit.PAID_PREMIUM,
        title: "I'm All In",
    },
    [UserRoles.FREE]: {
        personaLimit: 3,
        title: "Free",
    },
};
export { BANNED_USER_TEXT, PERSONA_ERRORS, PERSONAS_PER_SUBSCRIPTION };
